export default __webpack_public_path__ + "static/media/usp_3.0cfe6266.svg";